import { gql } from '@apollo/client';

export const CampaignDidUpdateMutation = gql`
  mutation CampaignDidUpdate($input: CampaignDidUpdateInput!) {
    campaignDidUpdate(campaignDidUpdateData: $input) {
      message
    }
  }
`;
